import { useLayoutEffect } from 'react';
import { usePromiseCounterIsTotalLoadingContext } from '@bingads-webui-react/counter-context';

export const useLoading = ({ setLoading }) => {
  // use isTotalLoading to include the scoped request count
  // in case any of the children also wrapped with PromiseCounterContext
  const { isTotalLoading } = usePromiseCounterIsTotalLoadingContext();

  useLayoutEffect(() => {
    if (setLoading) {
      setLoading(isTotalLoading);
    }
  }, [isTotalLoading, setLoading]);
};
